import { RgInteractionType } from "../rg-interactions.model";

export interface NotificationResultModel {
	action: NotificationResultRedirectAction;
	trigger: RgInteractionType;
}

export const enum NotificationResultRedirectAction {
	Continue = "Continue",
	Logout = "Logout",
	TimeoutPage = "Timeout Page",
	DepositLimitPage = "Deposit Limit Page",
	SelfExclusionPage = "Self Exclusion Page",
}

export const NOTIFICATION_RESULT_TRIGGER: Record<string, string> = {
	[RgInteractionType.Time]: "Time Trigger",
	[RgInteractionType.Loss]: "Loss Trigger",
	[RgInteractionType.Deposit]: "Deposit Trigger",
	[RgInteractionType.Wagering]: "Wagering Trigger",
	[RgInteractionType.Tools]: "Tools Trigger",
};
